export const TARGET_ADMIN_CLAIM = "TARGET_ADMIN";
export const TARGET_EDIT_CLAIM = "TARGET_EDIT";
export const NOSHOW_LATE_EDIT = "NOSHOW_LATE_EDIT"; // For handle bookings view and menu.
export const OPEN_AGREEMENT = "OPEN_AGREEMENT"; // For route prices view and menu.
export const OPEN_INVOICING = "OPEN_INVOICING";
export const UPDATE_ROUTE_PRICES = "UPDATE_ROUTE_PRICES";
export const OPEN_REBATE = "OPEN_REBATE";
